(function () {
  'use strict';

  function initAccordions() {
    document.querySelectorAll('[data-makeen-product-accordions]').forEach(function (accordionGroup) {
      var items = Array.prototype.slice.call(accordionGroup.querySelectorAll('[data-makeen-accordion-item]'));

      function getPanel(item) {
        return item.querySelector('.makeen-product-accordion__panel');
      }

      function finishTransition(panel, isOpening) {
        function onTransitionEnd(event) {
          if (event.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onTransitionEnd);

          if (isOpening) {
            panel.style.height = 'auto';
          } else {
            panel.style.removeProperty('height');
          }
        }

        panel.addEventListener('transitionend', onTransitionEnd);
      }

      function openItem(item, trigger, panel) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.style.height = '0px';

        window.requestAnimationFrame(function () {
          panel.style.height = panel.scrollHeight + 'px';
          finishTransition(panel, true);
        });
      }

      function closeItem(item, trigger, panel) {
        panel.style.height = panel.scrollHeight + 'px';

        window.requestAnimationFrame(function () {
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          panel.style.height = '0px';
          finishTransition(panel, false);
        });
      }

      items.forEach(function (item) {
        var trigger = item.querySelector('.makeen-product-accordion__trigger');
        var panel = getPanel(item);

        if (!trigger || !panel) return;

        if (item.classList.contains('is-open')) {
          panel.style.height = panel.scrollHeight + 'px';
        }

        trigger.addEventListener('click', function () {
          if (item.classList.contains('is-open')) {
            closeItem(item, trigger, panel);
          } else {
            openItem(item, trigger, panel);
          }
        });
      });

      accordionGroup.classList.add('is-ready');
    });
  }

  function initQuantitySteppers() {
    document.querySelectorAll('[data-makeen-quantity]').forEach(function (stepper) {
      if (stepper.hasAttribute('data-makeen-quantity-ready')) return;

      var input = stepper.querySelector('.makeen-quantity__input');
      var decreaseButton = stepper.querySelector('[data-makeen-quantity-decrease]');
      var increaseButton = stepper.querySelector('[data-makeen-quantity-increase]');

      if (!input || !decreaseButton || !increaseButton) return;

      function getNumber(value, fallback) {
        var number = Number(value);
        return Number.isFinite(number) ? number : fallback;
      }

      function getLimits() {
        return {
          min: getNumber(input.min, 1),
          max: input.max === '' ? Infinity : getNumber(input.max, Infinity),
          step: Math.max(getNumber(input.step, 1), 1)
        };
      }

      function clamp(value) {
        var limits = getLimits();
        return Math.min(limits.max, Math.max(limits.min, value));
      }

      function currentValue() {
        return clamp(Math.floor(getNumber(input.value, getLimits().min)));
      }

      function syncButtons() {
        var limits = getLimits();
        var value = currentValue();
        decreaseButton.disabled = value <= limits.min;
        increaseButton.disabled = value >= limits.max;
      }

      function setValue(value) {
        input.value = clamp(value);
        syncButtons();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      decreaseButton.addEventListener('click', function () {
        setValue(currentValue() - getLimits().step);
      });

      increaseButton.addEventListener('click', function () {
        setValue(currentValue() + getLimits().step);
      });

      input.addEventListener('input', syncButtons);
      input.addEventListener('change', function () {
        input.value = currentValue();
        syncButtons();
      });

      stepper.setAttribute('data-makeen-quantity-ready', 'true');
      syncButtons();
    });
  }

  function initProductDetails() {
    initAccordions();
    initQuantitySteppers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductDetails);
  } else {
    initProductDetails();
  }
}());
